/* SementePreviewManualSFD — prévia formatada da Semente
 * seguindo exatamente a estrutura do Manual SFD 2026.
 */
import { labelOf, CLASSIFICACOES, LINHAS_PESQUISA_SFD } from "@/lib/constants";

export default function SementePreviewManualSFD({ form, user, file }) {
  const src = form.source || {};
  const autores = src.autores || "—";
  const data = src.data_publicacao || "—";
  const link = src.link_original || src.link_drive || form.link_drive_excepcional || "—";
  const kw = (form.palavras_chave_sfd || []).filter(Boolean);
  const pesquisador = form.pesquisador_display || user?.name || "—";
  const classificacaoLabel = labelOf(CLASSIFICACOES, form.classificacao_semente);
  const linhaLabel = labelOf(LINHAS_PESQUISA_SFD, form.linha_pesquisa_sfd);

  return (
    <div
      className="border-2 border-[var(--gold)]/60 rounded-lg bg-white dark:bg-[var(--surface)] p-6 space-y-4 shadow-inner"
      data-testid="preview-manual-sfd"
    >
      <div className="border-b border-[var(--gold)]/40 pb-3">
        <div className="text-[10px] uppercase tracking-[0.22em] font-mono text-[var(--gold)] font-semibold">
          Semente de Futuro em Defesa · Manual SFD 2026
        </div>
        <h2
          className="font-display font-bold text-xl mt-1 leading-tight"
          data-testid="preview-sfd-titulo"
        >
          {form.titulo_insumo || "— título ausente —"}
        </h2>
      </div>

      <SFDSection label="DATA + FONTE" testid="preview-sfd-fonte">
        <span className="font-semibold">{data}</span>
        {src.origem_fonte && <> · {src.origem_fonte}</>}
        {src.tipo_fonte && <> · <em>{src.tipo_fonte}</em></>}
      </SFDSection>

      <SFDSection label="AUTOR" testid="preview-sfd-autor">
        {autores}
        {src.instituicao && <> · <span className="text-[var(--text-muted)]">{src.instituicao}</span></>}
      </SFDSection>

      <SFDSection label="DESCRIÇÃO" testid="preview-sfd-descricao">
        {form.descricao_semente || form.observacoes || <em className="text-[var(--text-muted)]">— não informado —</em>}
      </SFDSection>

      <SFDSection label="IMPACTOS FUTUROS EM DEFESA" testid="preview-sfd-impacto">
        {form.impacto_futuro_defesa || <em className="text-[var(--text-muted)]">— não informado —</em>}
      </SFDSection>

      <SFDSection label="SEMENTES DE FUTURO · Classificação" testid="preview-sfd-classificacao">
        <span className="font-semibold">{classificacaoLabel}</span>
        {linhaLabel && linhaLabel !== "—" && (
          <div className="text-[12px] text-[var(--text-muted)] mt-0.5">
            Linha de Pesquisa SFD: <span className="text-[var(--text)]">{linhaLabel}</span>
          </div>
        )}
      </SFDSection>

      <SFDSection label="PALAVRAS-CHAVE" testid="preview-sfd-kw">
        {kw.length ? (
          <div className="flex flex-wrap gap-1.5">
            {kw.map((k, i) => (
              <span
                key={`${k}-${i}`}
                className="text-[11px] font-mono px-2 py-0.5 rounded-full border border-[var(--gold)]/40 text-[var(--gold)] bg-[var(--gold)]/5"
              >
                {k}
              </span>
            ))}
          </div>
        ) : (
          <em className="text-[var(--text-muted)]">— não informadas —</em>
        )}
      </SFDSection>

      <SFDSection label="LINK DE ACESSO" testid="preview-sfd-link">
        {link !== "—" ? (
          <a href={link} target="_blank" rel="noreferrer" className="text-[var(--info)] hover:underline break-all">
            {link}
          </a>
        ) : (
          <em className="text-[var(--text-muted)]">— sem link —</em>
        )}
        {file && (
          <div className="text-[11.5px] text-[var(--text-muted)] mt-1">
            PDF anexo: <span className="font-mono">{file.name}</span>
          </div>
        )}
      </SFDSection>

      <SFDSection label="PESQUISADOR DO LSC" testid="preview-sfd-pesquisador">
        {pesquisador}
        {user?.email && !form.pesquisador_display && (
          <span className="text-[var(--text-muted)] ml-1">({user.email})</span>
        )}
      </SFDSection>

      {form.ai_used && (
        <div className="mt-3 pt-3 border-t border-dashed border-[var(--border)]">
          <div className="text-[10px] uppercase tracking-[0.22em] font-mono text-amber-700 dark:text-amber-400 font-semibold">
            Declaração de IA
          </div>
          <p className="text-[12.5px] mt-1">
            Uso de IA declarado: <strong>{form.ai_tool_name || "—"}</strong>
            {form.ai_usage_purpose && <> · finalidade: {form.ai_usage_purpose}</>}
            {" · "}
            {form.ai_human_verified ? (
              <span className="text-emerald-700 dark:text-emerald-400 font-semibold">revisado pelo pesquisador</span>
            ) : (
              <span className="text-rose-700 dark:text-rose-400 font-semibold">NÃO revisado</span>
            )}
          </p>
        </div>
      )}
    </div>
  );
}

function SFDSection({ label, testid, children }) {
  return (
    <section data-testid={testid}>
      <div className="text-[10px] uppercase tracking-[0.22em] font-mono text-[var(--gold)] font-semibold mb-1">
        {label}
      </div>
      <div className="text-[13.5px] leading-relaxed">{children}</div>
    </section>
  );
}
